import { Controller } from "@hotwired/stimulus"

// Handles star rating selection for review forms
// Place on a form that contains star buttons and a hidden input
export default class extends Controller {
  static targets = ["stars", "input"]

  connect() {
    this.selectedRating = 0
    this.updateDisplay()
  }

  select(event) {
    const button = event.currentTarget
    const rating = parseInt(button.dataset.starValue)
    this.selectedRating = rating
    this.inputTarget.value = rating
    this.updateDisplay()
  }

  // Show preview on hover (fill all stars up to hovered one)
  hover(event) {
    const button = event.currentTarget
    const rating = parseInt(button.dataset.starValue)
    this.highlightStars(rating)
  }

  // Reset to selected rating when mouse leaves
  leave() {
    this.updateDisplay()
  }

  // Highlight stars up to a given rating
  highlightStars(rating) {
    const buttons = this.starsTarget.querySelectorAll("button")
    buttons.forEach((button, index) => {
      const starIndex = index + 1
      if (starIndex <= rating) {
        button.classList.remove("text-gray-300")
        button.classList.add("text-yellow-400")
      } else {
        button.classList.remove("text-yellow-400")
        button.classList.add("text-gray-300")
      }
    })
  }

  // Update display to show selected rating
  updateDisplay() {
    this.highlightStars(this.selectedRating)
  }
}
